import { createSlice } from "@reduxjs/toolkit";

const baseState = {
  open: false,
  message: "",
  actionId: null,
  title: "Confirmar",
};

const initialState = {
  ...baseState,
};

export const confirmModalSlice = createSlice({
  name: "confirmModal",
  initialState,
  reducers: {
    setOpen: (state, action) => {
      state.open = action.payload.open;
      state.message = action.payload.message;
      state.actionId = action.payload.actionId;
      state.title = action.payload.title || "Confirmar";
    },
    setMessage: (state, action) => {
      state.message = action.payload.message;
    },
    setActionId: (state, action) => {
      state.actionId = action.payload;
    },
    setTitle: (state, action) => {
      state.title = action.payload;
    },
    closeModal: (state) => {
      state.open = false;
      state.message = "";
      state.actionId = null;
      state.title = "Confirmar";
    },
    ResetStore: (state) => {
      state = { ...baseState };
    },
  },
});

export const {
  setOpen,
  setMessage,
  setActionId,
  setTitle,
  closeModal,
  ResetStore,
} = confirmModalSlice.actions;

export default confirmModalSlice.reducer;
